module.exports = __webpack_public_path__ + "media/honey-icons/icon-paypal-22c98b6c.svg";